import React, {Component} from 'react';
import List, {ListItem} from 'material-ui/List';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';

class Solicitar extends Component {
    render() {
        if (!this.props.show) return null;
        
        const servicios = this.props.servicios.map((servicio, index) => (
            <ListItem 
                key={servicio.id}
                label={parseFloat(servicio.precio).bs()+' | '+servicio.descripcion}
                value={servicio.id+''}
                />
        ));

        return (
            <ListItem innerDivStyle={this.props.innerDivStyle} disableFocusRipple={true} disableTouchRipple={true}>
                <h4 style={this.props.titleStyle}>Soliticar Suscripcion</h4>
                <RadioButtonGroup name="plan" onChange={this.props.changeServicio} valueSelected={this.props.selected}>
                    {servicios}
                </RadioButtonGroup>
                <RaisedButton
                    style={{marginTop:10}} 
                    label="Solicitar"
                    onTouchTap={this.props.onSolicitar} 
                    primary={true}/>
            </ListItem>
    );
    }
}

export default Solicitar;


/** WEBPACK FOOTER **
 ** ./app-react/components/Suscripcion/Solicitar.jsx
 **/